var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFilterTicketIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-746 -2900)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(746 2900)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.81,2921.749h0a1.991,1.991,0,0,1-1.83-1.229l-4.96-11.97a1.855,1.855,0,0,1-.15-.8,2,2,0,0,1,1.23-1.8l7.37-3.05a1.99,1.99,0,0,1,2.6,1.08l4.961,11.97a1.962,1.962,0,0,1,0,1.514,1.991,1.991,0,0,1-1.088,1.086l-7.359,3.05A2.071,2.071,0,0,1,758.81,2921.749Zm2.41-17-7.35,3.039,4.96,11.96,7.35-3.05-4.95-11.949h-.01Zm-5.89,17h-1.45a2,2,0,0,1-2-2v-6.34l3.449,8.338Zm-5.459-1.54h0l-1.339-.559a2.018,2.018,0,0,1-1.09-2.61l2.43-5.86v9.028ZM757,2910a1,1,0,1,1,1-1A1,1,0,0,1,757,2910Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterTicketIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter_ticket_icon.cf60c3e8.svg";
export { ForwardRef as ReactComponent };